import React from "react";

import { bool, func, string } from "prop-types";

export default function Button({
  onClick,
  name,
  className,
  disabled = false,
  loading = false,
  ...rest
}) {
  return (
    <button
      className={`button ${className}`}
      onClick={onClick}
      disabled={disabled || loading}
      aria-busy={loading}
      {...rest}
    >
      {loading && <span className="button__loader" aria-hidden="true" />}
      {name}
    </button>
  );
}

Button.propTypes = {
  onClick: func,
  name: string.isRequired,
  className: string.isRequired,
  disabled: bool,
  loading: bool,
};
